
import type { PropType, Ref } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        checked: {
            type: Object as PropType<Ref<boolean>>,
            default: false,
        },
        label: {
            type: [String, null, undefined] as PropType<string | null | undefined>,
            default: null
        }
    },
    emits: ['change'],
    setup(props, { emit }) {
        const onClick = (event: Event) => {
            emit('change', event)
        }

        return {
            onClick
        }
    }
})
